module.exports = __webpack_public_path__ + "img/satisfied-smiley.08da0b42.svg";